// DELETE THIS WHEN MIGRATING TO REACT 18 - there is a better implementation of this baked in

import { useMemo } from 'react';

export function useId() {
  const id = useMemo(
    () =>
      Math.floor(Math.random() * Math.pow(10, 16))
        .toString(16)
        .padStart(16, '0'),
    [],
  );
  return id;
}
